import { Box } from '@mui/material';

interface OccurrenceBadgeProps {
  label: string;
  depth?: number;
}

export const OccurrenceBadge = ({ label, depth = 0 }: OccurrenceBadgeProps) => {
  const isNumbered = depth === 0;

  return (
    <Box
      data-testid={`av-logic-occurrence-badge-${label}`}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: (theme) => theme.spacing(6),
        height: (theme) => theme.spacing(6),
        borderRadius: '50%',
        fontSize: isNumbered ? 'body1.fontSize' : 'caption.fontSize',
        fontWeight: 700,
        lineHeight: 1,
        border: 1,
        borderColor: 'divider',
        color: 'text.primary',
        flexShrink: 0,
      }}
    >
      {label}
    </Box>
  );
};
